import ContentStyler from './ContentStyler';
export default ContentStyler;
